// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2Uwaa","paymentContainer":"PaymentPage_paymentContainer__2yUGA"};